import { render, staticRenderFns } from "./nuevaCabeceraDeInventario.vue?vue&type=template&id=6bc68f30&"
import script from "./nuevaCabeceraDeInventario.vue?vue&type=script&lang=js&"
export * from "./nuevaCabeceraDeInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports